module.exports = __webpack_public_path__ + "img/spot_trading.30b10412.png";